import { render, staticRenderFns } from "./CatalogSwitcher.vue?vue&type=template&id=e26d76e4&scoped=true"
import script from "./CatalogSwitcher.vue?vue&type=script&lang=js"
export * from "./CatalogSwitcher.vue?vue&type=script&lang=js"
import style0 from "./CatalogSwitcher.vue?vue&type=style&index=0&id=e26d76e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26d76e4",
  null
  
)

export default component.exports